import logo from "./images/logo.png";
import { Link } from "react-router-dom";

const Navbar = () => {
  window.onscroll = function () {
    var navbar = document.getElementById("navbar");
    if (navbar) {
      if (window.pageYOffset > 0) {
        navbar.classList.add("shadow");
      } else {
        navbar.classList.remove("shadow");
      }
    }
  };

  return (
    <nav class="navbar navbar-expand-sm fixed-top bg-white" id="navbar">
      <div class="pt-2 container-fluid">
        <div class="navbar-brand" href="#">
          <a href="https://norrenberger.com">
            <img
              src={logo}
              className="logo-img mb-2"
              style={{ width: "140px" }}
              alt="logo"
            />
          </a>
        </div>
        <button
          class="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#mynavbar"
        >
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="mynavbar">
          <ul class="navbar-nav ms-auto">
            <li class="nav-item">
              <Link to="/">
                <button className="custom-nav-link me-3 mt-2 mb-2">Home</button>
              </Link>
            </li>
            <li class="nav-item">
              <button
                className="custom-nav-link me-3 mt-2 mb-2"
                onClick={() => window.open("https://norrenberger.com/")}
              >
                {" "}
                Norrenberger
              </button>
            </li>
            <li class="nav-item">
              <button
                className="custom-nav-link me-3 mt-2 mb-2"
                onClick={() =>
                  window.open("https://customerportal.norrenberger.com/")
                }
              >
                {" "}
                Customer Portal
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
